import React from 'react';
import MainSidebar from './MainSidebar';
import { FiUsers, FiUser } from 'react-icons/fi';

export default function CRMSidebar() {
  const menuItems = [
    {
      id: 'thirdparties',
      title: 'Third-parties',
      links: [
        { path: '/crm/third-parties', label: 'List', icon: FiUsers },
        { path: '/crm/contacts', label: 'Contacts/Addresses', icon: FiUser }
      ]
    }
  ];
  
  return <MainSidebar moduleName="Third-Parties" menuItems={menuItems} />;
}